import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, X } from "lucide-react";
import { useState } from "react";

// Banner ad placeholder — shown only to free (non-subscribed) users.
export const AdBanner = ({ className = "", testid = "ad-banner" }) => {
  const { user } = useAuth();
  const [closed, setClosed] = useState(false);
  if (user && user.subscribed) return null; // subscribers never see ads
  if (closed) return null;

  return (
    <div className={`px-4 sm:px-8 ${className}`} data-testid={testid}>
      <div className="relative overflow-hidden rounded-xl border border-white/10 bg-gradient-to-r from-[#101010] via-[#0d0d0d] to-[#101010]">
        <div className="absolute top-2 right-2 flex items-center gap-2">
          <span className="font-mono-ui text-[9px] tracking-widest px-1.5 py-0.5 rounded border border-white/20 text-white/50">AD</span>
          <button onClick={() => setClosed(true)} data-testid="ad-banner-close" className="text-white/40 hover:text-white" aria-label="Close ad"><X size={14} /></button>
        </div>
        <div className="flex items-center justify-between gap-4 p-4 sm:p-5">
          <div className="flex items-center gap-4 min-w-0">
            <div className="w-12 h-12 rounded-lg bg-[#00F0FF]/10 border border-[#00F0FF]/30 flex items-center justify-center shrink-0">
              <Sparkles size={22} className="text-[#00F0FF]" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-medium text-white truncate">Your ad could be here — Advertisement placeholder</p>
              <p className="text-xs text-white/50 truncate">Tired of ads? Go Premium and watch uninterrupted.</p>
            </div>
          </div>
          <Link to="/premium" data-testid="ad-banner-cta" className="shrink-0 rounded-full bg-[#00F0FF] text-black text-xs sm:text-sm font-semibold px-4 py-2 hover:scale-105 transition-transform">
            Remove Ads
          </Link>
        </div>
      </div>
    </div>
  );
};
